<template>
  <div>
    <a-modal
      v-bind="attrs"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :centered="true"
      @cancel="cancel"
    >
      <a-form
        :model="states.formState"
        name="shareWorkflow"
        ref="formRef"
        layout="vertical"
        :rules="rules"
        autocomplete="off"
        class="mt-20 mb-20"
      >
        <a-form-item label="请选择工作空间" name="spaceName">
          <a-select
            v-model:value="states.formState.spaceName"
            placeholder="请选择工作空间"
            :options="options"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { Modal as AModal, Form as AForm, Select as ASelect, message } from 'ant-design-vue'
import { ref, reactive, useAttrs, getCurrentInstance } from 'vue'
import { shareWorkflowApi } from '@/service/api/workFlow.js'

const AFormItem = AForm.Item

const emits = defineEmits(['asyncSuccess'])
const { proxy } = getCurrentInstance()
const options = ref([
  {
    value: 'jack',
    label: 'Jack'
  },
  {
    value: 'lucy',
    label: 'Lucy'
  },
  {
    value: 'disabled',
    label: 'Disabled'
  },
  {
    value: 'yiminghe',
    label: 'Yiminghe'
  }
])
const rules = {
  spaceName: [
    {
      required: true,
      message: '不能为空',
      trigger: 'change'
    }
  ]
}
const attrs = useAttrs()
const states = reactive({
  formState: {
    spaceName: null
  }
})
const confirmLoading = ref(false)
const formRef = ref()

const cancel = () => {
  states.formState = {
    spaceName: null
  }
}
const handleOk = () => {
  formRef.value
    .validate()
    .then(() => {
      confirmLoading.value = true
      shareWorkflowApi({}).then((res) => {
        if (res.data) {
          message.success('分享成功')
          cancel()
          emits('asyncSuccess')
          proxy.$EventBus.emit('shareWorkflowMitt')
        }
        confirmLoading.value = false
      })
    })
    .catch(() => {})
}
</script>
